import activity from "./activity-constants";

// association of activities to entities
export const userEntity = "user";
export const orgEntity = "organization";
export const orgProfileEntity = "organizationprofile";
export const invitationEntity = "invitation";
export const invitationOrgEntity = "orginvitation";
export const categoryEntity = "category";
export const subcategoryEntity = "subcategory";
export const roleEntity = "role";
export const jobRoleWorkflowStepEntity = "jobroleworkflowstep";
export const jobRoleWorkflowQuestionEntity = "jobroleworkflowquestion";
export const jobRoleLevelEntity = "jobrolelevel";
export const jobEntity = "job";
export const jobMetadataEntity = "jobmetadata";
export const jobInterviewerEntity = "jobinterviewer";
export const jobCandidateOfferEntity = "jobcandidateoffer";
export const jobCandidateOfferUpdateEntity = "jobcandidateofferupdate";
export const jobCandidateOfferAcceptEntity = "jobcandidateofferaccept";
export const jobCandidateOfferDeclineEntity = "jobcandidateofferdecline";
export const jobCandidateArchiveEntity = "jobcandidatearchive";
export const jobCandidateAnswerEntity = "jobcandidateanswer";
export const candidateEntity = "candidate";
export const candidateJobEntity = "candidatejob";
export const candidateNoteEntity = "candidatenote";
export const candidateUrlEntity = "candidateurl";
export const candidateResumeImageEntity = "candidateresumeimage";
export const candidateResumeEntity = "candidateresume";
export const candidateDemographicsEntity = "candidatedemographics";
export const candidateMessageEntity = "candidatemessage";
export const recommendationEntity = "recommendation";
export const demographicQuestionEntity = "demographicquestion";
export const demographicOptionEntity = "demographicoption";
export const demographicResponseEntity = "demographicresponse";
export const locationEntity = "location";
export const appointmentEntity = "appointment";
export const disqualificationReasonEntity = "disqualificationreason";
export const jobCloseReasonEntity = "jobclosereason";
export const jobDescriptionReviewEntity = "jobdescriptionreview";
export const accessEntity = "access";
export const jobDescriptionEntity = "jobdescription";
export const jobDescriptionSectionEntity = "jobpostsection";
export const defaultJobPostSectionEntity = "defaultjobpostsection";
export const contentReviewEntity = "contentreview";
export const questionSetReviewEntity = "questionsetreview";
export const candidateAdvanceEntity = "candidateadvance";
export const skillEntity = "skill";
export const questionBankEntity = "questionbank";
export const scorecardDetailEntity = "scorecarddetail";
export const orgGalleryImageEntity = "orggalleryimage";
export const orgStatedValueEntity = "orgstatevalue";
export const jobTeamMemberEntity = "jobteammember";
export const staffEntity = "staff";
export const messageTemplateEntity = "messagetemplate";
export const jobDescriptionFileEntity = "jobdescriptionfile";
export const jobDescriptionFileRevisionEntity = "jobdescriptionfilerevision";
export const jobDescriptionFileAnnotationEntity =
  "jobdescriptionfileannotation";
export const jobRequirementEntity = "jobrequirement";
export const jobRequirementSignalEntity = "jobrequirementsignal";
export const aiSuggestionCacheEntity = "ai_suggestion_cache";
export const aiSuggestionCacheStatusEntity = "ai_suggestion_cache_status";
export const jobTaskEntity = "jobtask";
export const hiringPipelineEntity = "hiringpipeline";
export const jobMessageEntity = "jobmessage";
export const jobOwnerEntity = "jobowner";
export const externalSourceEntity = "externalsource";
export const occupationFamilyEntity = "occupationfamily";
export const systemOccupationEntity = "systemoccupation";
export const orgOccupationEntity = "orgoccupation";
export const systemExpertEntity = "systemexpert";
export const systemQuestionEntity = "systemquestion";
export const systemQuestionSetEntity = "systemquestionset";
export const meetingSettingsEntity = "meetingsettings";
export const jobUserEntity = "jobuser";
export const userAvailabilityEntity = "useravailability";
export const connectedAppEntity = "connectedapp";
export const interviewTrainerEntity = "interviewtrainer";
export const userProfileEntity = "userprofile";
export const jobExpertEntity = "jobexpert";
export const jobDisciplineEntity = "jobdiscipline";
// sales
export const salesContactEntity = "salescontact";
export const salesCampaignEntity = "salescampaign";
export const salesPipelineEntity = "salespipeline";
export const marketingPageEntity = "marketingpage";
export const marketingPageSectionEntity = "marketingpagesection";
export const marketingPageExtraFieldEntity = "marketingpageextrafield";
export const marketingLinkEntity = "marketinglink";
export const marketingPageAuthorEntity = "marketingpageauthor";
export const marketingPageCategoryEntity = "marketingpagecategory";
export const marketingPageSubcategoryEntity = "marketingpagesubcategory";
export const marketingPageCategoryPageEntity = "marketingpagecategorypage";
export const marketingPageSubcategoryPageEntity =
  "marketingpagesubcategorypage";
export const marketingEventEntity = "marketingevent";
export const marketingEventInstanceEntity = "marketingeventinstance";
export const marketingPlayEntity = "marketingplay";
export const marketingTestimonailEntity = "marketingtestimonial";
export const campaignPlaysEntity = "campaignplays";
export const engagementEventsEntity = "engagementevents";
export const engagementEventTypeEntity = "engagementeventtype";
export const followUpTypeEntity = "followuptypes";
export const followUpDispositionEntity = "followupdisposition";
export const engagementListEntity = "engagementlist";
export const companyEntity = "company";

// reports
export const pageViewEntity = "reportpageview";

export default {
  [activity.VIEW_DASHBOARD]: [
    connectedAppEntity,
    interviewTrainerEntity,
    jobInterviewerEntity,
    userAvailabilityEntity
  ],
  [activity.MANAGE_APPLICATION]: [
    orgEntity,
    invitationEntity,
    systemOccupationEntity,
    systemExpertEntity,
    systemQuestionEntity,
    systemQuestionSetEntity
  ],
  [activity.MANAGE_ORG]: [
    userEntity,
    orgProfileEntity,
    invitationOrgEntity,
    locationEntity,
    demographicQuestionEntity,
    demographicOptionEntity,
    disqualificationReasonEntity,
    jobCloseReasonEntity,
    categoryEntity,
    subcategoryEntity,
    externalSourceEntity,
    orgOccupationEntity,
    staffEntity
  ],
  [activity.MANAGE_OPPORTUNITIES]: [
    jobRoleWorkflowStepEntity,
    jobRoleWorkflowQuestionEntity,
    jobEntity,
    jobInterviewerEntity,
    recommendationEntity,
    skillEntity,
    hiringPipelineEntity,
    jobMessageEntity
  ],
  [activity.MANAGE_PEOPLE]: [candidateEntity],
  [activity.MANAGE_BULK_UPLOAD]: [candidateResumeEntity],
  [activity.VIEW_REPORTS]: [pageViewEntity],
  [activity.MANAGE_CONTENT]: [
    defaultJobPostSectionEntity,
    jobDescriptionEntity,
    jobDescriptionSectionEntity,
    messageTemplateEntity,
    orgGalleryImageEntity,
    orgStatedValueEntity
  ],
  [activity.MANAGE_SALES_ORG]: [
    userEntity,
    orgProfileEntity,
    invitationOrgEntity,
    locationEntity,
    engagementEventTypeEntity,
    followUpTypeEntity,
    followUpDispositionEntity
  ],
  [activity.MANAGE_SALES]: [
    salesContactEntity,
    salesCampaignEntity,
    salesPipelineEntity,
    jobMessageEntity
  ],
  [activity.MANAGE_MARKETING_CONTENT]: [
    marketingPageEntity,
    marketingPageSectionEntity,
    marketingPageExtraFieldEntity,
    marketingLinkEntity,
    marketingPageAuthorEntity,
    marketingPageCategoryEntity,
    marketingPageSubcategoryEntity,
    marketingPageCategoryPageEntity,
    marketingPageSubcategoryPageEntity,
    marketingEventEntity,
    marketingPlayEntity,
    marketingTestimonailEntity
  ],
  [activity.VIEW_ENGAGEMENT]: [engagementListEntity]
};
